<template>
    <div :class="['BaseTabs',className]">
        <div v-for="(item,index) in items"
             :key="item.id"
             :class="['BaseTabs__item',item.id==value?'BaseTabs__item_selected':'']"
             @click="change(item.id)">
            {{translate(item.name)}}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BaseTabs',
        props: {
            //Id of selected tab
            value: {
            },
            //Collection of objects with 'id' and 'name' to show in tabs
            items: {
                type: Array,
                required: true
            },
            //Additional css class name for styling
            className: {
                type: String
            }
        },
        methods: {
            change: function (e) {
                this.$emit('change', e);
            }
        }
    };
</script>

<style>
    .BaseTabs {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: stretch;
        background-color: #ECEFF1;
    }

    .BaseTabs__item {
        flex: 1 1 auto;
        color: rgba(0,0,0,.5);
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        width: 25%;
        text-align: center;
        padding: 8px;
        border-bottom: 2px solid rgba(0,0,0,0.05);
    }

    .BaseTabs__item_selected {
        color: #000;
        border-bottom: 2px solid #00BCD4;
    }
</style>



// WEBPACK FOOTER //
// BaseTabs.vue?2e11ee16